import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import {Player} from '../../shared/models/player';
import {SelectedPlayers} from '../models/player-filter';

export const removePlayerActionTypes = {
  REMOVE: type('[Player] Remove'),
  REMOVE_MULTI_SUBSCRIPTION: type('[Player Multi Subscription] Remove'),
  REMOVE_SUCCESS: type('[Player] Remove Success'),
  REMOVE_FAIL: type('[Player] Remove Fail'),
  REMOVE_SELECTION_PLAYER: type('[Player] Remove selected player')
};

export class RemovePlayerAction implements Action {
  readonly type = removePlayerActionTypes.REMOVE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}
export class RemoveMultiSubPlayerAction implements Action {
  readonly type = removePlayerActionTypes.REMOVE_MULTI_SUBSCRIPTION;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class RemovePlayerSuccessAction implements Action {
  readonly type = removePlayerActionTypes.REMOVE_SUCCESS;
  constructor(public payload?: ArrayResponse<Player>) {}
}

export class RemovePlayerFailAction implements Action {
  readonly type = removePlayerActionTypes.REMOVE_FAIL;
  constructor(public payload?: string) {}
}

export class RemovePlayerSelectionAction implements Action {
  readonly type = removePlayerActionTypes.REMOVE_SELECTION_PLAYER;
  constructor(public payload?: SelectedPlayers) {}
}
